import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { MainLayoutComponent } from './layouts/main-layout';

export const routes: Routes = [
  // Dashboard — full-bleed, no toolbar/margins
  {
    path: 'dashboard',
    loadComponent: () => import('./components/dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard],
  },

  // All other pages — wrapped in toolbar + margins layout
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: 'about', loadComponent: () => import('./components/about/about').then(m => m.About) },
      { path: 'plans', loadComponent: () => import('./components/subscription-plans/subscription-plans').then(m => m.SubscriptionPlansComponent) },
      { path: 'payment', loadComponent: () => import('./components/payment-form/payment-form').then(m => m.PaymentFormComponent) },
      { path: 'payment-confirmation', loadComponent: () => import('./components/payment-confirmation/payment-confirmation').then(m => m.PaymentConfirmationComponent) },
      { path: 'subscriptions', loadComponent: () => import('./components/list-subscriptions/list-subscriptions').then(m => m.ListSubscriptionsComponent), canActivate: [authGuard] },
      { path: 'login', loadComponent: () => import('./components/login/login').then(m => m.Login) },
      { path: '**', redirectTo: '/about' },
    ],
  },
];
